import axios from 'axios';
import { req } from './axiosFun';
import config from './config';

/**
 * 套餐管理
 **/
let url = config.apiBase

export const vpnVipPage = (params) => { return req("post", url + "/admin/vpnVipPage", params) };
export const refundPage = (params) => { return req("post", url + "/admin/refundPage", params) };
export const changePassword = (params) => { return req("post", url + "/admin/web/changePassword", params) };
export const refundAdd = (params) => { return req("post", url + "/admin/refundAdd", params) };
export const refundAudit = (params) => { return req("post", url + "/admin/refundAudit", params) };
export const noticePage = (params) => { return req("post", url + "/admin/noticePage", params) };
export const feedBackPage = (params) => { return req("post", url + "/admin/feedBackPage", params) };
export const appStoreCheckPage = (params) => { return req("post", url + "/admin/appStoreCheckPage", params) };
export const vpnVipAdd = (params) => { return req("post", url + "/admin/vpnVipAdd", params) };
export const vpnVipUpdate = (params) => { return req("post", url + "/admin/vpnVipUpdate", params) };
export const noticeAdd = (params) => { return req("post", url + "/admin/noticeAdd", params) };
export const noticeEdit = (params) => { return req("post", url + "/admin/noticeEdit", params) };
export const appStoreCheckAdd = (params) => { return req("post", url + "/admin/appStoreCheckAdd", params) };
export const appStoreCheckEdit = (params) => { return req("post", url + "/admin/appStoreCheckEdit", params) };
export const vpnVipGet = (params) => { return req("post", url + "/admin/vpnVipGet", params) };
export const vpnVipDelete = (params) => { return req("post", url + "/admin/vpnVipDelete", params) };
// 线路列表
export const vpnLinePage = (params) => { return req("post", url + "/admin/vpnLinePage", params) };
export const cityVoteResult = (params) => { return req("post", url + "/report/cityVoteResult", {}) };
export const linkCountOnLine = (params) => { return req("post", url + "/report/linkCountOnLine", {}) };
export const vpnRefreshTime = (params) => { return req("post", url + "/report/vpnRefreshTime", {}) };

// 升级管理
export const appVersionPage = (params) => { return req("post", url + "/admin/appVersionPage", params) };
export const appVersionAdd = (params) => { return req("post", url + "/admin/appVersionAdd", params) };
export const appVersionEdit = (params) => { return req("post", url + "/admin/appVersionEdit", params) };
// 提现审核

export const userCrashPage = (params) => { return req("post", url + "/admin/userCrashPage", params) };
// 提现审核

export const userCrashAudit = (params) => { return req("post", url + "/admin/userCrashAudit", params) };
export const OrderList = (params) => { return req("post", url + "/admin/web/orderPage", params) };
export const userRefunds = (params) => { return req("post", url + "/admin/web/userRefunds", params) };
export const userComplaint = (params) => { return req("post", url + "/admin/web/userComplaint", params) };


export const regUserReport = (params) => { return req("post", url + "/admin/regUserReport", params) };
export const vipTypeReport = (params) => { return req("post", url + "/admin/vipTypeReport", params) };
export const userPayOrderReport = (params) => { return req("post", url + "/admin/userPayOrderReport", params) };
export const userRefundOrderReport = (params) => { return req("post", url + "/admin/web/userRefundOrderReport", params) };
// 云手机套餐类型
export const vipTypeList = (params) => { return req("post", url + "/admin/vipTypeList", params) };
export const vipTypePhoneReport = (params) => { return req("post", url + "/admin/vipTypePhoneReport", params) };

/**
 * 每日会员类型付费笔数/金额报表（新增）
 * 后端对接规范见 docs/api/vipTypeDailyReport.md
 * 请求体：{ startRq:"yyyy-MM-dd", endRq:"yyyy-MM-dd" }（字段名是 startRq/endRq）
 * 响应（统一包裹 {code,msg,data}，成功码 0）：
 *   推荐 data：{ dates:[...], types:[5种], series:{ 类型:[笔数...] }, amountSeries:{ 类型:[金额...] } }
 *   备选 data：{ list:[{ date, type, count, amount }, ...] }
 * amountSeries/list.amount 为可选扩展字段（缺省按0，不影响笔数）。
 * 前端支持「笔数/金额/笔数+金额」三种指标视图。
 * 注意：前端已不使用演示数据，接口必须返回真实数据（code=0）；失败时前端会直接提示错误。
 * 接口路径以当前实现为准（/admin/web/vipTypeDailyReport）。
 */
export const vipTypeDailyReport = (params) => { return req("post", url + "/admin/web/vipTypeDailyReport", params) };

export const channelPhoneReport = (params) => { return req("post", url + "/admin/channelPhoneReport", params) };

// 补单
export const payResult = (params) => { return req("get", url + "/admin/web/payresult", params) };

// 客诉记录
export const complaintsPage  = (params) => { return req("post", url + "/admin/web/userComplaint", params) };
export const dealUserComplaint  = (params) => { return req("post", url + "/admin/web/dealUserComplaint", params) };

// 答复
export const complaintsReplay  = (params) => { return req("post", url + "/admin/complaintsReplay", params) };



// WEBPACK FOOTER //
// ./src/api/payMG.js